export function getOrderStatusDestination(
  department: string | null | undefined,
  geomapDepartments: string[],
  currentStateCode: string | null | undefined
): string {
  const normalizedDepartment = department?.trim().toUpperCase() ?? '';
  const normalizedStateCode = currentStateCode?.trim().toUpperCase() ?? '';
  const isGeomapDepartment = geomapDepartments.some(
    (code) => code.trim().toUpperCase() === normalizedDepartment
  );

  return normalizedDepartment && isGeomapDepartment && normalizedStateCode === 'AUTOFAILED'
    ? '/Location/geomap'
    : '/Audit/auditdashboard/orderStatusTracker';
}
